module.exports = function() { return __webpack_public_path__ + "cabin-blue-create-account-page.2djjZSO8zwIgb9mLUmui.svg";};